type PriceAmount = { amount?: number | null } | null | undefined;

export const toPayableAmount = (
  price: PriceAmount,
  discount?: { discountedPrice: { amount: number } } | null
): number | undefined => discount?.discountedPrice.amount ?? price?.amount ?? undefined;
